var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.buttonText)?_c('gd-button',{staticClass:"h-10 px-4 bg-blue btn-radius font-semibold text-base hover:bg-blue-dark focus:bg-black",class:[
    'button-bg-color button-style button-text-color button-border-color',
  ],style:([_vm.customCss]),attrs:{"primary":"","size":"auto"},on:{"click":function($event){return _vm.buttonCallback(_vm.callbackParam)}}},[_vm._v(_vm._s(_vm.buttonText))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }